import { FC, useContext } from 'react';

// Components
import { ArrowDownIcon, ConfigContext } from '@velinsi/smp-widgets-ui';

// Utils
import { classNames, getLabelValue } from '@sportal365/smp-widget-utils';

interface Props {
  isMenuOpen: boolean;
  handleMenuOpen: () => void;
  round?: string;
  stage?: string;
  hasMultipleStages: boolean;
}

const DropdownButton: FC<Props> = ({ isMenuOpen, hasMultipleStages, handleMenuOpen, round, stage }) => {
  const { dataLabels } = useContext(ConfigContext);

  return (
    <div
      className={classNames({
        'dropdown-button h-[42px] rounded-3 bg-pillBackgroundColor flex items-center justify-between cursor-pointer px-3 relative border-[1px] border-solid border-dropdownBorderColor':
          true,
        'border-[#FF901A]': isMenuOpen,
      })}
      onClick={handleMenuOpen}
    >
      <div style={{ display: 'flex', alignItems: 'center', whiteSpace: 'pre', overflow: 'hidden' }} className='dropdown-button-information'>
        <p className='dropdown-button-round-name m-0 text-4 font-bold text-hiContrast leading-[24px]'>
          {getLabelValue(dataLabels?.round, 'Round')} {round}
        </p>
        <p
          className={classNames({
            'dropdown-button-stage-name m-0 text-[#8c8c8c] whitespace-pre overflow-hidden text-ellipsis text-4': true,
            hidden: !hasMultipleStages,
          })}
        >
          {' - '}
          {stage}
        </p>
      </div>
      <div className='dropdown-button-icon'>
        <ArrowDownIcon isActive={isMenuOpen} />
      </div>
    </div>
  );
};

export default DropdownButton;
